import React from "react";
import styles from "./styles.css";
import MoreCarsForYouCard from "../more-cars-for-you-card/component";
import PropTypes from "prop-types";
import H2Blue from "../../shared/h2-bule/component";

const MoreCarsForYouRevamp = ({content,
    config,
    allFilters,
    resetCarListConnect,
    reloadCarListConnect,
    updateSelectedOnScreenFilterConnect,
    updateAppliedFiltersConnect,
    clearAllFiltersConnect}) => {
    const {moreCars = [] } = content || {};
    return (
        <div styleName={"styles.revampWrapper"}>
            <H2Blue text="More cars for you" fontWeight="700" />
            <div styleName={"styles.cardOuter"}>
                {
                    moreCars.map(item => {
                        return (<MoreCarsForYouCard item={item}
                            config={config}
                            allFilters={allFilters}
                            resetCarListConnect={resetCarListConnect}
                            reloadCarListConnect={reloadCarListConnect}
                            updateSelectedOnScreenFilterConnect={updateSelectedOnScreenFilterConnect}
                            updateAppliedFiltersConnect={updateAppliedFiltersConnect}
                            clearAllFiltersConnect={clearAllFiltersConnect}
                        />);
                    })
                }
            </div>
        </div>
    );
};
MoreCarsForYouRevamp.propTypes = {
    content: PropTypes.object,
    allFilters: PropTypes.object,
    updateSelectedOnScreenFilterConnect: PropTypes.func,
    reloadCarListConnect: PropTypes.func,
    clearAllFiltersConnect: PropTypes.func,
    updateAppliedFiltersConnect: PropTypes.func,
    resetCarListConnect: PropTypes.func,
    config: PropTypes.object,
    isCdpRevamp: PropTypes.bool
};
export default MoreCarsForYouRevamp;
